import * as React from 'react';
import {Swords, Trophy, User} from 'lucide-react';
import {Challenge, CombatUser} from '../ChallengesIndex.type';
import {getStatusLabel, getChallengeTypeLabel, getStatusBadgeClass} from '../ChallengesIndex.map';

interface CombatantProps {
  user: CombatUser;
  isWinner: boolean;
}

function Combatant({user, isWinner}: CombatantProps) {
  return (
    <div className={`challenges-combatant${isWinner ? ' challenges-combatant--winner' : ''}`}>
      <div className="challenges-combatant__avatar-wrap">
        {user.avatarUrl ? (
          <img
            src={user.avatarUrl}
            alt={user.name ?? 'Usuário'}
            className="challenges-combatant__avatar"
          />
        ) : (
          <div className="challenges-combatant__avatar challenges-combatant__avatar--empty">
            <User size={20} />
          </div>
        )}
        {isWinner && (
          <div className="challenges-combatant__winner-crown" aria-label="Vencedor">
            <Trophy size={14} />
          </div>
        )}
      </div>
      <span className="challenges-combatant__name">
        {user.name ?? 'Usuário deletado'}
      </span>
    </div>
  );
}

interface CombatRowProps {
  challenge: Challenge;
}

export function CombatRow({challenge}: CombatRowProps) {
  const challengerWon = challenge.winner?.id === challenge.challenger.id;
  const challengedWon = challenge.winner?.id === challenge.challenged.id;

  return (
    <article className="challenges-combat-row">
      <div className="challenges-combat-row__arena">
        <Combatant user={challenge.challenger} isWinner={challengerWon} />
        <div className="challenges-combat-row__vs" aria-hidden="true">
          <Swords size={20} />
          <span>VS</span>
        </div>
        <Combatant user={challenge.challenged} isWinner={challengedWon} />
      </div>

      <div className="challenges-combat-row__meta">
        {challenge.title && (
          <p className="challenges-combat-row__title">{challenge.title}</p>
        )}
        <div className="challenges-combat-row__tags">
          <span className={`challenges-badge ${getStatusBadgeClass(challenge.status)}`}>
            {getStatusLabel(challenge.status)}
          </span>
          <span className="challenges-badge challenges-badge--muted">
            {getChallengeTypeLabel(challenge.challengeType)}
          </span>
        </div>
        {challenge.winner && (
          <p className="challenges-combat-row__result">
            <Trophy size={14} />
            Vencedor: {challenge.winner.name ?? 'Usuário deletado'}
          </p>
        )}
      </div>
    </article>
  );
}
